<template lang="pug">

  .answers__list
    .answer(v-for="(answer, key) in questData.answers" :key="key" :class="{ answer_active : choosed === key }")
      .answer__question-wrap
        .answer__question(@click="$emit('answer', key)")
          p {{ answer.text }}

      transition(name="bounce")
        .answer__info(v-show="choosed === key" :class="{ isBlue: isFirst }")
          header.answer__stats(v-if="answer.modificator && !isFirst")

            template(v-for="(answer, index) in answer.modificator")
              ScoreItem(:value="answer" :type="index")

          .answer__cnt
            p {{ answer.description }}

          ButtonItem(
            text="Дальше",
            type="button"
            classList="button_dark button_sm"
            @click.native="$emit('next')")

</template>

<script>
  import ButtonItem from '@/components/ButtonItem.vue';
  import ScoreItem from '@/components/ScoreItem.vue';
  // import anime from 'animejs';

  export default {
    name: 'AnswersList',
    components: {
      ButtonItem,
      ScoreItem
    },
    props: {
      questData: {
        type: Object,
        required: true
      },
      isFirst: {
        type: Boolean,
        required: false
      },
      choosed: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        listEl: null
      }
    },
    mounted() {
      this.listEl = document.querySelector('.answers__list');
    }
  }
</script>

<style scoped lang="stylus">
.answers
  &__list
    margin-top 2rem
    @media $tablet
      margin-top 4rem
      padding-right 15%
    .answer:nth-child(n + 3)
      .answer__question-wrap:before
        left 2%
        right 5%
      .answer__question, .answer__question-wrap:after
        clip-path: polygon(0 0, 100% 0, 95% 100%, 2% 100%);
    &_active
      .answer:not(.answer_active)
        opacity 0.2
        pointer-events none
.answer
  margin-bottom 1.5rem
  &__question
    position relative
    padding 2rem 2.5rem
    user-select: none

    background-color: $white
    cursor pointer
    clip-path polygon(4% 0, 96% 0, 100% 100%, 0% 100%)
    transition all 0.15s ease
    @media $tablet
      padding 3.9rem 5rem
    &:hover
      @media $tablet
        background-color $pink
        color $white

    &-wrap
      position relative
      z-index 9
      &:before
        position: absolute
        left: -2px
        right: -2px
        bottom: -2px
        z-index: 6

        height: 0.5rem

        content: ''
        box-shadow: 0 3px 2px 0 rgba(0,0,0,0.3)
      &:after
        position absolute
        top -3px
        right -3px
        left -3px
        bottom -3px
        z-index -1

        background-color #000
        pointer-events none
        clip-path polygon(4% 0, 96% 0, 100% 100%, 0% 100%)
        content ''

  &__cnt
    text-align left
    p
      font-size: 1.6rem
      letter-spacing: -0.2px
      line-height: 1.375
  &__info
    position relative
    z-index 3

    padding 2rem

    text-align center

    background-color rgb(246, 240, 255)
    // display none
    @media $tablet
      left: -4.7rem
      right: -5rem

      width: calc( 100% + 9.7rem )
      margin-top: -5.8rem
      padding: 7.8rem 5rem 2rem 4.7rem

      clip-path: polygon(0 10%, 100% 0, 96% 100%, 4% 100%)

    &.isBlue
      background-color: rgba(199,223,254,0.5)
    .button
      margin-top 2rem
  &__stats
    display flex
    align-items center
    justify-content space-between
    margin-bottom 2rem

    font-weight 600
    font-size 1.2rem
    color: #0942E2
    letter-spacing: -0.22px
    text-align: center
    line-height: 1.11
    @media $tablet
      font-size: 1.8rem
    .border
      width 1px
      height 2rem
      background-color rgba(#000, 0.1)
      @media $tablet
        width 2px
        height 4rem

  &_active
    .answer__question
      background-color $pink
      color $white

.bounce-enter-active
  animation: bounce-in .5s

@keyframes bounce-in
  0%
    transform: scale(0)

  50%
    transform: scale(1.05)

  100%
    transform: scale(1)


</style>
